export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    //游戏列表 
    paymentGamesData: function paymentGamesData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentGames/paymentGamesData',
        method: 'get',
        data: data
      });
    },
    //游戏新增
    paymentGamesAdd: function paymentGamesAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentGames/paymentGamesAdd',
        method: 'post',
        data: data
      });
    },
    //游戏修改
    paymentGamesUpdate: function paymentGamesUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentGames/paymentGamesUpdate',
        method: 'post',
        data: data
      });
    },
    //游戏删除
    paymentGamesDel: function paymentGamesDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentGames/paymentGamesDel',
        method: 'post',
        data: data
      });
    },
    //地区列表 
    paymentGamesServersData: function paymentGamesServersData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentGamesServers/paymentGamesServersData',
        method: 'get',
        data: data
      });
    },
    //地区新增
    paymentGamesServersAdd: function paymentGamesServersAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentGamesServers/paymentGamesServersAdd',
        method: 'post',
        data: data
      });
    },
    //地区修改
    paymentGamesServersUpdate: function paymentGamesServersUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentGamesServers/paymentGamesServersUpdate',
        method: 'post',
        data: data
      });
    },
    //地区删除
    paymentGamesServersDel: function paymentGamesServersDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentGamesServers/paymentGamesServersDel',
        method: 'post',
        data: data
      });
    },
    //地区所有
    paymentGamesServersAll: function paymentGamesServersAll() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentGamesServers/paymentGamesServersAll',
        method: 'get',
        data: data
      });
    },
    //商品列表 
    paymentProductsData: function paymentProductsData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentProducts/paymentProductsData',
        method: 'get',
        data: data
      });
    },
    //商品新增
    paymentProductsAdd: function paymentProductsAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentProducts/paymentProductsAdd',
        method: 'post',
        data: data
      });
    },
    //商品修改
    paymentProductsUpdate: function paymentProductsUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentProducts/paymentProductsUpdate',
        method: 'post',
        data: data
      });
    },
    //商品删除
    paymentProductsDel: function paymentProductsDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentProducts/paymentProductsDel',
        method: 'post',
        data: data
      });
    },
    //商品VIP列表 
    vipPaymentProductsData: function vipPaymentProductsData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentProducts/vipPaymentProductsData',
        method: 'get',
        data: data
      });
    },
    //商品VIP新增
    vipPaymentProductsAdd: function vipPaymentProductsAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentProducts/vipPaymentProductsAdd',
        method: 'post',
        data: data
      });
    },
    //商品VIP修改
    vipPaymentProductsUpdate: function vipPaymentProductsUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentProducts/vipPaymentProductsUpdate',
        method: 'post',
        data: data
      });
    },
    //商品VIP删除
    vipPaymentProductsDel: function vipPaymentProductsDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentProducts/vipPaymentProductsDel',
        method: 'post',
        data: data
      });
    },
    payConfigurationLogList: function payConfigurationLogList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationLogList',
        method: 'get',
        data: data
      });
    },
    payConfigurationLogAdd: function payConfigurationLogAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationLogAdd',
        method: 'post',
        data: data
      });
    },
    payConfigurationLogUpdate: function payConfigurationLogUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationLogUpdate',
        method: 'post',
        data: data
      });
    },
    payConfigurationLogDel: function payConfigurationLogDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationLogDel',
        method: 'post',
        data: data
      });
    },
    payConfigurationSlideshowList: function payConfigurationSlideshowList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationSlideshowList',
        method: 'get',
        data: data
      });
    },
    payConfigurationSlideshowAdd: function payConfigurationSlideshowAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationSlideshowAdd',
        method: 'post',
        data: data
      });
    },
    payConfigurationSlideshowDel: function payConfigurationSlideshowDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationSlideshowDel',
        method: 'post',
        data: data
      });
    },
    payConfigurationSlideshowUpdate: function payConfigurationSlideshowUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationSlideshowUpdate',
        method: 'post',
        data: data
      });
    },
    payConfigurationCooperationList: function payConfigurationCooperationList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationCooperationList',
        method: 'get',
        data: data
      });
    },
    payConfigurationCooperationAdd: function payConfigurationCooperationAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationCooperationAdd',
        method: 'post',
        data: data
      });
    },
    payConfigurationCooperationUpdate: function payConfigurationCooperationUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationCooperationUpdate',
        method: 'post',
        data: data
      });
    },
    payConfigurationCooperationDel: function payConfigurationCooperationDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationCooperationDel',
        method: 'post',
        data: data
      });
    },
    payConfigurationClauseList: function payConfigurationClauseList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationClauseList',
        method: 'get',
        data: data
      });
    },
    payConfigurationClauseAdd: function payConfigurationClauseAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationClauseAdd',
        method: 'post',
        data: data
      });
    },
    payConfigurationClauseDel: function payConfigurationClauseDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationClauseDel',
        method: 'post',
        data: data
      });
    },
    payConfigurationClauseUpdate: function payConfigurationClauseUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationClauseUpdate',
        method: 'post',
        data: data
      });
    },
    payConfigurationPrivacyList: function payConfigurationPrivacyList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationPrivacyList',
        method: 'get',
        data: data
      });
    },
    payConfigurationPrivacyAdd: function payConfigurationPrivacyAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationPrivacyAdd',
        method: 'post',
        data: data
      });
    },
    payConfigurationPrivacyDel: function payConfigurationPrivacyDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationPrivacyDel',
        method: 'post',
        data: data
      });
    },
    payConfigurationPrivacyUpdate: function payConfigurationPrivacyUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationPrivacyUpdate',
        method: 'post',
        data: data
      });
    },
    payConfigurationFooterList: function payConfigurationFooterList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationFooterList',
        method: 'get',
        data: data
      });
    },
    payConfigurationFooterAdd: function payConfigurationFooterAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationFooterAdd',
        method: 'post',
        data: data
      });
    },
    payConfigurationFooterDel: function payConfigurationFooterDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationFooterDel',
        method: 'post',
        data: data
      });
    },
    payConfigurationFooterUpdate: function payConfigurationFooterUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/payConfiguration/payConfigurationFooterUpdate',
        method: 'post',
        data: data
      });
    },
    getDelayedTasks: function getDelayedTasks() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentGamesServers/getDelayedTasks',
        method: 'get',
        data: data
      });
    },
    getDelayedTaskDetail: function getDelayedTaskDetail() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'api/paymentGamesServers/getDelayedTaskDetail',
        method: 'get',
        data: data
      });
    }
  };
});